import { render, staticRenderFns } from "./Banner_service.vue?vue&type=template&id=cce3f6b6&scoped=true&"
import script from "./Banner_service.vue?vue&type=script&lang=js&"
export * from "./Banner_service.vue?vue&type=script&lang=js&"
import style0 from "./Banner_service.vue?vue&type=style&index=0&id=cce3f6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce3f6b6",
  null
  
)

export default component.exports